import React, { Suspense } from "react"
import type { MileageRequestMap as MileageRequestMapComponent } from "~Components/forms/expenseForm/reimbursementForms/mileage/mileageRequestMap"
import { Loading } from "~Components/loading"
import { lazily } from "~Shared/utils/react.utils"

// mapbox-gl (+ mapbox-gl-draw and turf) adds ~1.4 MB minified but is only shown
// for mileage expenses — load it on demand instead of in the entry chunk
const { MileageRequestMap: LazyMileageRequestMap } = lazily(() => import("~Components/forms/expenseForm/reimbursementForms/mileage/mileageRequestMap"))

export const MileageRequestMap = (props: React.ComponentProps<typeof MileageRequestMapComponent>) => (
    <Suspense fallback={<Loading margin={false} />}>
        <LazyMileageRequestMap {...props} />
    </Suspense>
)
